import React, { useState, useEffect } from "react";
import axios from 'axios';
import Logo from "../components/Logo";
import DrinkArray from "../components/DrinkList/DrinkArray";
import FilterPanel from "../components/DrinkList/FilterPanel";
import {FaEraser, FaChevronCircleDown, FaChevronCircleUp} from "react-icons/fa";
import "../format/DrinkList.css";
import AccountShortcut from "../components/AccountShortcut";

const DrinkList = ({setShowLoader, user, setUser, searchText, setSearchText, searchIngredient, setSearchIngredient, searchTags, setSearchTags, myBarSearch, setMyBarSearch, removeCookie}) => {

    const [drinkList, setDrinkList] = useState([]);
    const [filterPanelShown, setFilterPanelShown] = useState(false);
    const [featuredMenuName, setFeaturedMenuName] = useState('');
    const [listLoaded, setListLoaded] = useState(false);
    const [dbDrinkCount, setDbDrinkCount] = useState(0);


    useEffect(() => {
        axios.get('/api/drink_count')
            .then((res) => {
                if (res.data) {
                    setDbDrinkCount(res.data);
                }
            }).catch((err) => console.log(err));
        getDrinkList();
    }, [searchText, searchIngredient, searchTags, myBarSearch]);

    function getDrinkList() {
        if(showEraser()){
            axios.get('/api/search', {params : {searchText: searchText, tags: searchTags, ingredient: searchIngredient, user_id: myBarSearch.user_id, tol: myBarSearch.tol, strict: myBarSearch.strict, no_na: myBarSearch.no_na}})
                .then((res) => {
                    if (res.data) {
                        setDrinkList(res.data);
                        setFeaturedMenuName('');
                        setListLoaded(true);
                    }
                }).catch((err) => console.log(err));
        } else {
            axios.get('/api/menu/featured')
                .then((res) => {
                    if (res.data) {
                        if(res.data.menu_id) {
                            setDrinkList(res.data.drinkList);
                            setFeaturedMenuName(res.data.name);
                        } else {
                            setFeaturedMenuName('No featured menu');
                            setDrinkList([]);
                        }
                        setListLoaded(true);
                    }
                }).catch((err) => console.log(err));
        }
    }

    function toggleFilterPanel(){
        if(!filterPanelShown){
            expandFilterPanel();
            setFilterPanelShown(true);
        } else {
            collapseFilterPanel();
            setFilterPanelShown(false);
        }
    }

    function expandFilterPanel() {
        const filterPanel = document.querySelector(".filter-panel");
        filterPanel.style.height = filterPanel.scrollHeight + 'px';
        filterPanel.addEventListener('transitioned', function () {
            filterPanel.removeEventListener('transitioned');
            filterPanel.style.height = null;
        });
    }

    function collapseFilterPanel() {
        const filterPanel = document.querySelector(".filter-panel")
        requestAnimationFrame(function () {
            filterPanel.style.height = filterPanel.scrollHeight + 'px';
            requestAnimationFrame(function () {
                filterPanel.style.height = 0 + 'px';
            })
        });
    }

    function clearSearchParams() {
        setSearchText('');
        setSearchTags([]);
        setSearchIngredient('');
        setMyBarSearch({});
    }

    function showEraser(){
        return (searchText && searchText !== '') || searchTags.length > 0 || searchIngredient !=='' || myBarSearch.user_id;
    }

    function setSearchPlaceholder(){
        if(featuredMenuName !== '' || (searchTags.length === 0 && searchIngredient === '' && !myBarSearch.user_id)){
            return("Search all " + (dbDrinkCount > 0 ? dbDrinkCount+" ":"") + "cocktails");
        } else {
            return("Search " + (drinkList.length > 0 ? drinkList.length+" ":"") + "of " + (dbDrinkCount > 0 ? dbDrinkCount+" ":"") + "filtered results");
        }
    }

    function setFilterInstructions(){
        if(featuredMenuName !== ''){
            return("Looking for more? Pick from all "+(dbDrinkCount > 0 ? dbDrinkCount+" ":"")+"cocktails by choosing a spirit or style at the top");
        } else {
            return("Showing " + (drinkList.length > 0 ? drinkList.length+" ":"") + "of " + (dbDrinkCount > 0 ? dbDrinkCount+" ":"") + "cocktails matching your filters");
        }
    }

    return (
        <>
            <AccountShortcut user={user} setUser={setUser} removeCookie={removeCookie}/>
            <header>
                <Logo/>
                <div className="search-container">
                    <input name='search-bar' className="search-bar" autoComplete="off" type="text" placeholder={setSearchPlaceholder()} value={searchText} onChange={(e) => {setSearchText(e.target.value)}}/>
                    <div className='filter-toggle'>
                        {!filterPanelShown && <FaChevronCircleDown style={{cursor:"pointer", marginRight: '10px'}} onClick={toggleFilterPanel}/>}
                        {filterPanelShown && <FaChevronCircleUp style={{cursor:"pointer", marginRight: '10px'}} onClick={toggleFilterPanel}/>}
                    </div>
                    <div className='filter-eraser'>
                        {showEraser() && <FaEraser style={{cursor:"pointer"}} onClick={clearSearchParams}/>}
                    </div>
                </div>
            </header>
            <div className="filter-panel">
                <FilterPanel expandFilterPanel={expandFilterPanel} toggleFilterPanel={toggleFilterPanel} user={user} searchIngredient={searchIngredient} setSearchIngredient={setSearchIngredient} searchTags={searchTags} setSearchTags={setSearchTags} myBarSearch={myBarSearch} setMyBarSearch={setMyBarSearch}/>
            </div>
            {listLoaded && <>
                {featuredMenuName !== '' && <h1 className="menu-title">{featuredMenuName}</h1>}
                {featuredMenuName === '' && <h1 className="menu-title">{"Search Results" + (drinkList.length > 0 ? (" ("+drinkList.length+")"):"")}</h1>}
                <DrinkArray drinkList={drinkList} getDrinkList={getDrinkList} setShowLoader={setShowLoader}/>
                <>
                    <hr className="list-separator"></hr>
                    <p className="looking-for-more">{setFilterInstructions()}</p>
                </>
            </>}
        </>
    )
}

export default DrinkList;